import React from "react";
import { useTheme } from "styled-components";
import { NoPreviewFlowHeader } from "../layout/header/FlowHeader";
import StaticHeader from "../layout/header/StaticHeader";
import LoadingPage from "./LoadingPage";

export const StaticLoadingScreen = ({ text = "Laster" }: { text?: string }) => (
  <>
    <StaticHeader />
    <LoadingPage text={text} />
  </>
);

export const FlowNoPreviewLoadingScreen = ({
  text = "Laster",
}: {
  text?: string;
}) => {
  const theme = useTheme();
  return (
    <>
      <NoPreviewFlowHeader />
      <LoadingPage text={text} color={theme.nafColor.primary.dew} />
    </>
  );
};
